import { render, staticRenderFns } from "./OrderDraftCustomer.vue?vue&type=template&id=79d78f7a&"
import script from "./OrderDraftCustomer.vue?vue&type=script&lang=js&"
export * from "./OrderDraftCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports